import { render, staticRenderFns } from "./requestor.vue?vue&type=template&id=535d3c61&scoped=true&"
import script from "./requestor.vue?vue&type=script&lang=js&"
export * from "./requestor.vue?vue&type=script&lang=js&"
import style0 from "./requestor.vue?vue&type=style&index=0&id=535d3c61&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535d3c61",
  null
  
)

export default component.exports